import BaseModel from 'models/base-model';
export default class ReportPreviewPage extends BaseModel({
  selectedElementId: null,
  selectedElementsSectionId: null,
  isClickedOnReport: null,
  reOrderedcolumnList: [],
  reportPreviewPageDisplayOptions: [],
}) {
  get selectedElementDetails() {
    return this;
  }

  setSelectedElementDetails({
    selectedElementId,
    sectionId,
    isClickedOnReport,
  }) {
    return this.merge({
      selectedElementId,
      selectedElementsSectionId: sectionId,
      isClickedOnReport,
    });
  }
  clearReportPreviewPageData() {
    return this.merge({
      selectedElementId: null,
      selectedElementsSectionId: null,
      isClickedOnReport: null,
    });
  }
  clearSelectedElementsSectionId() {
    return this.merge({ selectedElementsSectionId: null });
  }
  setReorderedColumnList(reOrderedcolumnList) {
    return this.merge({ reOrderedcolumnList });
  }
  setReportPreviewPageDisplayOptions(reportPreviewPageDisplayOptions) {
    return this.merge({ reportPreviewPageDisplayOptions });
  }
}
